import React, { useEffect, useRef, useState } from 'react';
import { MotifButton, MotifFormField, MotifSearch, MotifToggleSwitch } from '@ey-xd/motif-react';
import { UploadSvgIcon, downloadIcon } from '../../common/MotifIcons';
import { MAX_ARC_DOWNLOAD_SELECTION } from '../../common/contants/constants';
import './partnerFileUpload.scss';

export const TableHeader = ({ onFilterTextBoxChanged, searchValue, manageAccess, isDisabled, convertClientEngagement, toggleChecked, isConvertClientDisabled, isEngagementAdmin, callingFrom, passwordReminder, openExportExcel, showExportExcel = false, isExportExcelLoading = false, isExportExcelDisabled = false, openImportExcel, showImportExcel = false, isImportExcelLoading = false, showSearch = true, showDescription = false, showDownloadFiles = false, isDownloadFilesEnabled = false, openDownloadFiles }) => {
  const [isImportExportOpen, setIsImportExportOpen] = useState(false);
  const importExportRef = useRef(null);
  const showImportExportControl = isEngagementAdmin && (showExportExcel || showImportExcel);
  const isExportDisabled = isExportExcelLoading || isExportExcelDisabled;

  useEffect(() => {
    if (!isImportExportOpen) return undefined;
    const handleDocumentClick = (event) => {
      if (!importExportRef.current?.contains(event.target)) {
        setIsImportExportOpen(false);
      }
    };
    document.addEventListener('mousedown', handleDocumentClick);
    return () => document.removeEventListener('mousedown', handleDocumentClick);
  }, [isImportExportOpen]);

  const handleImportClick = () => {
    if (isImportExcelLoading) return;
    if (openImportExcel) openImportExcel();
    setIsImportExportOpen(false);
  };

  const handleExportClick = () => {
    if (isExportDisabled) return;
    if (openExportExcel) openExportExcel();
    setIsImportExportOpen(false);
  };

  return (
    <div className='grid-header'>
      <div className='header-text'>
        <span className='header-title'>Data Upload</span>
        {showDescription && <span className='header-description'>Please open each row to add files to that engagement</span>}
      </div>
      <div className='header-controls'>
        {showSearch && <div className='header-input-partner'>
          <MotifFormField>
            <MotifSearch
              aria-label='Search'
              onChange={(e) => onFilterTextBoxChanged(e.target?.value)}
              placeholder='Search ...'
              value={searchValue}
            />
          </MotifFormField>
        </div>}
        <div className='header-actions'>
          {isEngagementAdmin && <><div style={{ borderLeft: '1px solid #C3C3CB', height: '32px', margin: '0 5px' }} /><MotifFormField className="convert-engagement-container" onClick={!isConvertClientDisabled ? convertClientEngagement : undefined} style={{ cursor: isConvertClientDisabled ? 'default' : 'pointer' }}>
            <MotifToggleSwitch checked={toggleChecked} offLabel={<span className="convert-toggle-label">Convert to<br />Client Engagement</span>} disabled={isConvertClientDisabled} onLabel='' />
          </MotifFormField><div style={{ borderLeft: '1px solid #C3C3CB', height: '32px', margin: '0 5px' }} /></>}

          {isEngagementAdmin && (
            <MotifButton
              variant='secondary'
              className="password-reminder-btn"
              onClick={() => passwordReminder()}
              disabled={isDisabled}
              title={isDisabled ? 'Select an engagement to enable/disable password reminder.' : ''}
            >
              <img
                loading='lazy'
                src="data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZmlsbC1ydWxlPSJldmVub2RkIiBjbGlwLXJ1bGU9ImV2ZW5vZGQiIGQ9Ik00LjM3NTk2IDguNTgzOTdDNC42MDU3MyA4LjIzOTMzIDUuMDcxMzggOC4xNDYyIDUuNDE2MDMgOC4zNzU5Nkw5LjUgMTEuMDk4NkwxMy41ODQgOC4zNzU5NkMxMy45Mjg2IDguMTQ2MiAxNC4zOTQzIDguMjM5MzMgMTQuNjI0IDguNTgzOTdDMTQuODUzOCA4LjkyODYyIDE0Ljc2MDcgOS4zOTQyNyAxNC40MTYgOS42MjQwNEw5LjkxNjAzIDEyLjYyNEM5LjY2NDEgMTIuNzkyIDkuMzM1OSAxMi43OTIgOS4wODM5OCAxMi42MjRMNC41ODM5OCA5LjYyNDA0QzQuMjM5MzMgOS4zOTQyNyA0LjE0NjIgOC45Mjg2MiA0LjM3NTk2IDguNTgzOTdaIiBmaWxsPSIjOTg5OEE4Ii8+CjxwYXRoIGZpbGwtcnVsZT0iZXZlbm9kZCIgY2xpcC1ydWxlPSJldmVub2RkIiBkPSJNMyA1Ljc1QzIuMzA5NjQgNS43NSAxLjc1IDYuMzA5NjQgMS43NSA3VjE3QzEuNzUgMTcuNjkwNCAyLjMwOTY0IDE4LjI1IDMgMTguMjVIMTdDMTcuNDE0MiAxOC4yNSAxNy43NSAxOC41ODU4IDE3Ljc1IDE5QzE3Ljc1IDE5LjQxNDIgMTcuNDE0MiAxOS43NSAxNyAxOS43NUgzQzEuNDgxMjIgMTkuNzUgMC4yNSAxOC41MTg4IDAuMjUgMTdWN0MwLjI1IDUuNDgxMjIgMS40ODEyMiA0LjI1IDMgNC4yNUgxNkMxNy41MTg4IDQuMjUgMTguNzUgNS40ODEyMiAxOC43NSA3VjljMCAwLjQxNDIxLTAuMzM1OCAwLjc1LTAuNzUgMC43NUMxNy41ODU4IDkuNzUgMTcuMjUgOS40MTQyMSAxNy4yNSA5VjdDMTcuMjUgNi4zMDk2NCAxNi42OTA0IDUuNzUgMTYgNS43NUgzWiIgZmlsbD0iIzk4OThBOCIvPgo8cGF0aCBmaWxsLXJ1bGU9ImV2ZW5vZGQiIGNsaXAtcnVsZT0iZXZlbm9kZCIgZD0iTTIwLjUzMDMgMTAuNDY5N0MyMC44MjMyIDEwLjc2MjYgMjAuODIzMiAxMS4yMzc0IDIwLjUzMDMgMTEuNTMwM0wxOC44MTA3IDEzLjI1SDIzQzIzLjQxNDIgMTMuMjUgMjMuNzUgMTMuNTg1OCAyMy43NSAxNEMyMy43NSAxNC40MTQyIDIzLjQxNDIgMTQuNzUgMjMgMTQuNzVIMTguODEwN0wyMC41MzAzIDE2LjQ2OTdDMjAuODIzMiAxNi43NjI2IDIwLjgyMzIgMTcuMjM3NCAyMC41MzAzIDE3LjUzMDNDMjAuMjM3NCAxNy44MjMyIDE5Ljc2MjYgMTcuODIzMiAxOS40Njk3IDE3LjUzMDNMMTYuNDY5NyAxNC41MzAzQzE2LjE3NjggMTQuMjM3NCAxNi4xNzY4IDEzLjc2MjYgMTYuNDY5NyAxMy40Njk3TDE5LjQ2OTcgMTAuNDY5N0MxOS43NjI2IDEwLjE3NjggMjAuMjM3NCAxMC4xNzY4IDIwLjUzMDMgMTAuNDY5N1oiIGZpbGw9IiM5ODk4QTgiLz4KPC9zdmc+Cg=="
                color="Secondary"
                autoFocus
              />
              Password Reminder
            </MotifButton>
          )}

          {callingFrom !== 'adminPage' && (
            <MotifButton
              variant='secondary'
              className="manage-access-btn"
              onClick={() => manageAccess()}
              disabled={isDisabled}
              title={isDisabled ? 'Select an engagement to grant user access.' : ''}
            >
              <img
                loading='lazy'
                src={require("../../common/images/user-star.png")}
                color="Secondary"
                autoFocus
                className='manage-access-icon'
              />
              Manage Access
            </MotifButton>
          )}

          {showDownloadFiles && isEngagementAdmin && (
            <div className="tooltip download-files-tooltip">
              <MotifButton
                variant='secondary'
                className="download-files-btn"
                onClick={() => { if (isDownloadFilesEnabled && openDownloadFiles) openDownloadFiles(); }}
                disabled={!isDownloadFilesEnabled}
              >
                <img
                  loading='lazy'
                  src={downloadIcon}
                  alt=''
                  aria-hidden='true'
                  className={`download-files-icon${isDownloadFilesEnabled ? '' : ' download-files-icon--disabled'}`}
                />
                Download
              </MotifButton>
              <span className="tooltiptext">{`Bulk Download is available only for ARC engagements with status No files, Failed or Download Error. you can select maximum of ${MAX_ARC_DOWNLOAD_SELECTION} engagements at a time.`}</span>
            </div>
          )}

          {showImportExportControl && (
            <div ref={importExportRef} style={{ position: 'relative', display: 'inline-flex', alignItems: 'stretch' }}>
              <MotifButton
                className='filter-header-button'
                style={{ color: '#1a1a1aff', fontWeight: '400', minWidth: '130px', whiteSpace: 'nowrap', borderTopRightRadius: 0, borderBottomRightRadius: 0, borderRight: 'none' }}
                variant='secondary'
                title='Import / Export'
              >
                Import / Export
              </MotifButton>
              <MotifButton
                className='filter-header-button'
                style={{ minWidth: '36px', padding: '0 10px', borderTopLeftRadius: 0, borderBottomLeftRadius: 0 }}
                variant='secondary'
                onClick={() => setIsImportExportOpen((prev) => !prev)}
                title='Import / Export options'
              >
                {isImportExportOpen ? '▲' : '▼'}
              </MotifButton>

              {isImportExportOpen && (
                <div
                  role='menu'
                  style={{
                    position: 'absolute',
                    top: 'calc(100% + 6px)',
                    right: 0,
                    minWidth: '120px',
                    background: '#fff',
                    border: '1px solid #d8d8de',
                    borderRadius: '4px',
                    boxShadow: '0 4px 10px rgba(0,0,0,0.12)',
                    zIndex: 10,
                    padding: '4px 0',
                  }}
                >
                  {showImportExcel && (
                    <button
                      type='button'
                      role='menuitem'
                      onClick={handleImportClick}
                      disabled={isImportExcelLoading}
                      style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'left', padding: '8px 12px', cursor: isImportExcelLoading ? 'not-allowed' : 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                      <img
                        loading='lazy'
                        src={downloadIcon}
                        alt=''
                        aria-hidden='true'
                        style={{ width: '14px', height: '14px', opacity: 0.65 }}
                      />
                      <span>{isImportExcelLoading ? 'Importing...' : 'Import'}</span>
                    </button>
                  )}
                  {showExportExcel && (
                    <button
                      type='button'
                      role='menuitem'
                      onClick={handleExportClick}
                      disabled={isExportDisabled}
                      style={{ width: '100%', border: 'none', background: 'transparent', textAlign: 'left', padding: '8px 12px', cursor: isExportDisabled ? 'not-allowed' : 'pointer', fontSize: '14px', display: 'flex', alignItems: 'center', gap: '8px' }}
                    >
                      <img
                        loading='lazy'
                        src={UploadSvgIcon}
                        alt=''
                        aria-hidden='true'
                        style={{ width: '14px', height: '14px', opacity: 0.65 }}
                      />
                      <span>{isExportExcelLoading ? 'Exporting...' : 'Export'}</span>
                    </button>
                  )}
                </div>
              )}
            </div>
          )}
          {callingFrom === 'adminPage' && showExportExcel && (
                    <MotifButton
                      className='filter-header-button'
                      style={{ color:'#1a1a1aff', paddingLeft:'2%', fontWeight: '400', minWidth: '150px', whiteSpace: 'nowrap' }}
                      variant='secondary'
                      onClick={() => openExportExcel && openExportExcel()}
                      title='Export Excel'
                      disabled={isExportExcelLoading}
                    >
                      <img
                        loading='lazy'
                        style={{ width: '18px', height: '18px', marginRight: '5px' }}
                        src={require("../../common/images/microsoft-excel.png")}
                        color="Secondary"
                        autoFocus
                        className='manage-access-icon'
                      />
                      {isExportExcelLoading ? 'Exporting...' : 'Export to Excel'}
                    </MotifButton>
                  )}
        </div>
      </div>
    </div>
  );
};